import React from 'react';

import { Pressable } from '@rbilabs/universal-components';
import { Platform, StyleSheet } from 'react-native';

import { Box, BoxProps, withTypography } from 'components/ui';
import { getDesignToken, layout, primitive, spacing } from 'styles/constants';

export const Container = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.container, style] });

export const NotificationWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.notificationWrapper, style] });

export const IconContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.iconContainer, style] });

export const DetailsContainer = Pressable.withConfig({
  flex: '1',
  marginLeft: '4',
});

export const Heading = withTypography({
  variant: 'headerTwo',
  color: primitive.$mayoEggWhite,
  mb: '$0',
});

export const Details = withTypography({ color: primitive.$mayoEggWhite, fontSize: 'xs' });

export const Close = Pressable.withConfig({
  marginRight: '$2',
});

export const ActionContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style });

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: getDesignToken('color-contrast-background'),
    height: spacing.$16,
    justifyContent: 'center',
    padding: spacing.$2,
    elevation: 3,
    shadowColor: '#000000',
    shadowOffset: { height: 1, width: 0 },
    shadowOpacity: 0.22,
    shadowRadius: 2.22,
    ...(Platform.OS === 'web' ? ({ cursor: 'pointer' } as any) : {}),
  },
  iconContainer: { marginLeft: spacing.$2 },
  notificationWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    maxWidth: Number.parseInt(getDesignToken('layout-section-max-width'), 10),
    width: layout.full,
  },
});
